import PropTypes from "prop-types";
import React from 'react';
import ServiceData from '../../data/services/services.json';
import IconBox from '../../components/IconBox/IconBox.jsx';
import SectionTitle from '../../components/SectionTitles/SectionTitle';


const ServiceIconBox = ({ classOption, endText }) => {

    const titleText = `Our Team Offers a Wide Range of Insulation Options${endText}`;
    return (
        <div className={`section section-padding-t50-b100 ${classOption}`}>
            <div className="container">

                <SectionTitle
                    title={titleText}
                    subTitle="We proudly offer an extensive range of insulation products. We deliver attention to detail and extensive product knowledge, ensuring the best insulation for your home or business."
                />

                <div className="row row-cols-lg-3 row-cols-md-2 row-cols-sm-2 row-cols-1 mb-n6">

                    {ServiceData && ServiceData.slice(0, 3).map((single, key) => {
                            return(
                                <div key={key} className="col mb-6" data-aos="fade-up">
                                    <IconBox classOption="box-border" data={single} key={key} />
                                </div>
                            ); 
                    })}

                </div>
                <br></br>
                <div className="row row-cols-lg-3 row-cols-md-2 row-cols-sm-2 row-cols-1 mb-n6">

                    {ServiceData && ServiceData.slice(3, 6).map((single, key) => {
                        return(
                            <div key={key} className="col mb-6" data-aos="fade-up">
                                <IconBox classOption="box-border" data={single} key={key} />
                            </div>
                        );
                    })}

                </div>
                <br></br>
                <div className="row row-cols-lg-3 row-cols-md-2 row-cols-sm-2 row-cols-1 mb-n6">

                    {ServiceData && ServiceData.slice(6, 9).map((single, key) => {
                        return(
                            <div key={key} className="col mb-6" data-aos="fade-up">
                                <IconBox classOption="box-border" data={single} key={key} />
                            </div>
                        );
                    })}

                </div>

            </div>
        </div>
    )
}

ServiceIconBox.propTypes = {
    classOption: PropTypes.string
  };
  ServiceIconBox.defaultProps = {
    classOption: "section section-padding-t90-b100"
};

export default ServiceIconBox;
